import React from 'react';
import {
  List,
  Datagrid,
  TextField,
  Create,
  Edit,
  SimpleForm,
  LongTextInput,
  EditButton,
  DateField,
  NumberField,
  NumberInput,
  SaveButton,
  Toolbar,
  TabbedForm,
  FormTab,
  ReferenceInput,
  SelectInput,
  FileInput,
  FileField,
  ReferenceField,
  BooleanField,
  BooleanInput
} from 'react-admin';

const required = (message = 'Required') =>
  value => value ? undefined : message;

export const ImageFormatter = v => {
  // console.log("====LogoFormatter=====: ", v);
  if (typeof v === 'object') {
    return v;
  }
  const imageObj = {
    "src": v
  }
  return v
    ? imageObj
    : v;
}

export const ImageParser = v => {
  // console.log("====LogoParser=====: ", v);
  // console.log(v);
  if (typeof v === 'object') {
    return v;
  }

  return v.src
    ? v.src
    : v;
}

export const AudioList = (props) => (
  <List {...props} title="List of Category" bulkActionButtons={false}>
    <Datagrid>
      <DateField source="created_at" showTime/>
      <ReferenceField label="Category" source="category" reference="music-categories">
        <TextField source="title" />
      </ReferenceField>
      <TextField source="title"/>
      <NumberField source="order"/>
      <BooleanField source="isPremium"/>
      <DateField source="updated_at" showTime/>
      <EditButton/>
    </Datagrid>
  </List>
);

export const AudioCreate = (props) => (
  <Create {...props}>
    <SimpleForm redirect="/audio">
      <LongTextInput source="title" validate={required()}/>
      <LongTextInput source="description" />
      <ReferenceInput label="category" source="category" reference="music-categories">
        <SelectInput optionText="title" />
      </ReferenceInput>
      <FileInput source="url" label="Related files" accept="audio/*"
                 format={ImageFormatter} parse={ImageParser}>
        <FileField source="src" title="title"/>
      </FileInput>
      <NumberInput source="order"/>
      <BooleanInput source="isPremium"/>
    </SimpleForm>
  </Create>
);

const EditToolbar = props => (
  <Toolbar {...props} >
    <SaveButton/>
  </Toolbar>
);

export const AudioEdit = (props) => (
  <Edit {...props} undoable={false}>
    <TabbedForm redirect="/audio">
      <FormTab label="Audio Info">
        <LongTextInput source="title" validate={required()}/>
        <LongTextInput source="description" />
        <ReferenceInput label="category" source="category" reference="music-categories">
          <SelectInput optionText="title" />
        </ReferenceInput>
        <FileInput source="url" label="Related files" accept="audio/*"
                   format={ImageFormatter} parse={ImageParser}>
          <FileField source="src" title="title"/>
        </FileInput>
        <NumberInput source="order"/>
        <BooleanInput source="isPremium"/>
      </FormTab>
    </TabbedForm>
  </Edit>
);